module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mtorn1-15538b518db64ef9a701128393d5fbe7.jpg";